import React from 'react'

import { FieldProps, InteriorQualityString } from '../../../../../../../@types/types'
import { SCREEN_OTHER_FACILITIES, SCREENS } from '../../../../../../../services/domain/wizardScreens'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import ChipOptionField from '../../../../../../common/inputs/chipOptionField/ChipOptionField'

const screen = SCREENS[SCREEN_OTHER_FACILITIES]

const InteriorQuality: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({ insertionData, onChange }) => {
  return (
    <div className='grid-item'>
      <ChipOptionField
        id='interior-quality'
        propertyName='interiorQuality'
        option={insertionData.interiorQuality}
        options={InteriorQualityString}
        translation='wizard.screen.otherFacilities.'
        labelTranslationKey='wizard.screen.otherFacilities.interiorQuality'
        onChange={(value) => onChange({ screen: screen.name, property: 'interiorQuality' }, value)}
      />
    </div>
  )
}

export default InteriorQuality
